import { CatalogSection } from "@/components/CatalogSection";

export default function HomeCatalog() {
    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-2xl font-semibold text-slate-900">Home Catalog</h1>
                <p className="mt-1 text-sm text-slate-600">
                    Manage and review the active home models available for quoting.
                </p>
            </div>
            <CatalogSection />
        </div>
    );
}
